import * as React from 'react'
import SocialAccount from '../../../models/socialAccount'
import FooterLink from '../../../models/footerLink'
import SocialIcon from './SocialIcon'
import { Link } from '../../../components/link'
import { DictionaryValue } from '../../../components/dictionary-value'
import './Footer.scss'
import Partners from '../../../components/partners/Partners'
import EventType from '../../../models/eventType'
import { setEmarsysWebExtend } from '../../../utilities'

export type FooterVariation = 'default' | 'under-full-width'

export type FieldProps = {
    socialAccounts: SocialAccount[]
    links: FooterLink[]
    year: string
    variation?: FooterVariation
    eventType?: EventType
    isEventRunning: boolean
    loading: boolean
}

export type Props = FieldProps

class Footer extends React.Component<Props> {
    componentDidUpdate(oldProps: Props) {
        if (oldProps.loading && !this.props.loading) {
            setTimeout(() => setEmarsysWebExtend(undefined, undefined, undefined, true), 500)
        }
    }

    render() {
        const { socialAccounts, links, year, variation = 'default', eventType, isEventRunning } = this.props
        const classnames = `footer${eventType &&
            ` ${isEventRunning ? `footer--${eventType}` : `footer--${eventType}-standard`}`
        }`

        return (
            <>
                <Partners variation={variation} />
                <footer className={classnames}>
                    <div className='footer__link-section'>
                        <ul className='footer__social-icons'>
                            {socialAccounts.map(icon => <SocialIcon key={`${icon.type}${icon.account}`} icon={icon} />)}
                        </ul>
                        <ul className='footer__links'>
                            {links.map(link =>
                                <li key={`${link.name}${link.path}`} className='footer__link-item'>
                                    <Link to={link.path} className='footer__link'>
                                        {link.name}
                                    </Link>
                                </li>
                            )}
                        </ul>
                    </div>
                    <p className='footer__copyright'>
                        &copy; {year} <DictionaryValue token='footer.copyright' />
                    </p>
                </footer>
            </>
        )
    }
}

export default Footer
